<template>
  <div class="integralShop">
    <div class="peak">
      <img src="@/assets/images/top.png" alt="" />
      <h4 class="title">积分商城</h4>
    </div>
    <div class="background" :class="{ active: selectBg }">
      <img :src="pageConfig.integralShop.backgroundSrc" @click="selectModule('background')" />
      <!-- 控制条 -->
      <div class="controlBarWrap" v-show="bgControlState">
        <ul class="controlList">
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe68f;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe691;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe690;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe692;</i>
          </li>
        </ul>
      </div>
    </div>
    <!-- 等级积分模块 -->
    <div
      class="scoreSet"
      :class="{ mrb10: !pageConfig.integralShop.pageComponents[0].hideGaps }"
      @click="selectModule(pageConfig.integralShop.pageComponents[0])"
    >
      <div class="setWrap" :class="{ active: pageConfig.integralShop.pageComponents[0].select }">
        <div class="left">
          <span>当前积分</span>
          <span>2563</span>
        </div>
        <div class="right">
          <img :src="pageConfig.integralShop.uploadIcon" class="uploadImg" alt="" />
          活动记录
        </div>
      </div>
      <!-- 控制条 -->
      <div class="controlBarWrap" v-show="pageConfig.integralShop.pageComponents[0].select">
        <ul class="controlList">
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe68f;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe691;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe690;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe692;</i>
          </li>
        </ul>
      </div>
    </div>

    <!-- 列表 -->
    <transition-group name="flip-list" tag="ul" ref="list" class="list">
      <template v-for="data in pageConfig.integralShop.pageComponents">
        <!-- 兑换实物列表 :key="'component' + index + 'task'" -->
        <li v-if="data.id == 8" :key="data.id + 'actual'" :data-id="data.id" :class="{ active: data.select }">
          <div class="activityList" :class="{ active: data.select, mrb10: !data.hideGaps }" @click="selectModule(data)">
            <h4>兑换实物</h4>
            <template v-for="item in pageConfig.integralShop.actualList">
              <div class="activityItem" :key="item.id + 'actualList'" v-if="item.visibility">
                <img :src="item.imageUrl" class="activityIcon" />
                <div class="activityInfo">
                  <span class="name">{{ item.goodName || item.activityName }}</span>
                  <span class="desc">{{ item.desc }}</span>
                  <span class="time"
                    >活动日期:
                    {{ moment(new Date(item.startTime)).format("YYYY.MM.DD") }}
                    -
                    {{ moment(new Date(item.endTime)).format("YYYY.MM.DD") }}</span
                  >
                </div>
                <div class="joinBtn">立即兑换</div>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </li>
        <!-- 兑换优惠券列表  :key="'component' + index + 'task'" -->
        <li v-if="data.id == 9" :key="data.id + 'coupon'" :data-id="data.id" :class="{ active: data.select }">
          <div class="activityList" :class="{ active: data.select, mrb10: !data.hideGaps }" @click="selectModule(data)">
            <h4>兑换优惠券</h4>
            <template v-for="item in pageConfig.integralShop.couponList">
              <div class="activityItem" :key="item.id + 'couponList'" v-if="item.visibility">
                <img :src="item.imageUrl" class="activityIcon" />
                <div class="activityInfo">
                  <span class="name">{{ item.goodName || item.activityName }}</span>
                  <span class="desc">{{ item.desc }}</span>
                  <span class="time"
                    >活动日期:
                    {{ moment(new Date(item.startTime)).format("YYYY.MM.DD") }}
                    -
                    {{ moment(new Date(item.endTime)).format("YYYY.MM.DD") }}
                  </span>
                </div>
                <div class="joinBtn">立即兑换</div>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </li>

        <!-- 兑换京豆  :key="'component' + index + 'task'" -->
        <li v-if="data.id == 29" :key="data.id + 'jingdou'" :data-id="data.id" :class="{ active: data.select }">
          <div class="activityList" :class="{ active: data.select, mrb10: !data.hideGaps }" @click="selectModule(data)">
            <h4>兑换京豆</h4>
            <template v-for="item in pageConfig.integralShop.jingdouList">
              <div class="activityItem" :key="item.id + 'couponList'" v-if="item.visibility">
                <img :src="item.imageUrl" class="activityIcon" />
                <div class="activityInfo">
                  <span class="name">{{ item.goodName || item.activityName }}</span>
                  <span class="desc">{{ item.desc }}</span>
                  <span class="time"
                    >活动日期:
                    {{ moment(new Date(item.startTime)).format("YYYY.MM.DD") }}
                    -
                    {{ moment(new Date(item.endTime)).format("YYYY.MM.DD") }}
                  </span>
                </div>
                <div class="joinBtn">立即兑换</div>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </li>

        <!-- 兑换Eka  :key="'component' + index + 'task'" -->
        <li v-if="data.id == 30" :key="data.id + 'ek'" :data-id="data.id" :class="{ active: data.select }">
          <div class="activityList" :class="{ active: data.select, mrb10: !data.hideGaps }" @click="selectModule(data)">
            <h4>兑换E卡</h4>
            <template v-for="item in pageConfig.integralShop.ekList">
              <div class="activityItem" :key="item.id + 'couponList'" v-if="item.visibility">
                <img :src="item.imageUrl" class="activityIcon" />
                <div class="activityInfo">
                  <span class="name">{{ item.goodName || item.activityName }}</span>
                  <span class="desc">{{ item.desc }}</span>
                  <span class="time"
                    >活动日期:
                    {{ moment(new Date(item.startTime)).format("YYYY.MM.DD") }}
                    -
                    {{ moment(new Date(item.endTime)).format("YYYY.MM.DD") }}
                  </span>
                </div>
                <div class="joinBtn">立即兑换</div>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </li>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Sortable from "sortablejs";

export default {
  computed: {
    ...mapState(["pageConfig"]),
  },
  data() {
    return {
      selectBg: false,
      bgControlState: false,
      domList: [],
    };
  },
  mounted() {
    console.log(this.pageConfig, 222222);
    this.init();
  },
  methods: {
    ...mapMutations(["componentListChange", "addComponent", "switchConfigState", "toppingComponent", "upAndDown", "delComponent"]),

    init() {
      let self = this;
      let options = {
        animation: 500,
        dataIdAttr: "data-id",
        filter: ".filter",
        sort: false,
        group: { name: "list", pull: false, put: true },
        onAdd(evt) {
          const arr = sortList.toArray();
          self.componentListChange(+evt.oldIndex);
          self.addComponent(arr);
          self.domList.push({
            id: evt.clone.dataset.id,
            dom: evt.clone,
          });
          evt.clone.className = "wrap";
          evt.item.remove();
        },
        onEnd: function(evt) {},
      };
      var sortList = Sortable.create(this.$refs.list.$el, options);
    },
    selectModule(data) {
      console.log(data);
      if (data === "background") {
        if (this.selectBg) return;
        this.selectBg = true;
        this.bgControlState = true;
        this.pageConfig.integralShop.pageComponents.forEach((item) => (item.select = false));
        this.switchConfigState(0);
      } else {
        this.selectBg = false;
        this.bgControlState = false;
        if (data.select) return;
        this.pageConfig.integralShop.pageComponents.forEach((item) => (item.select = false));
        data.select = true;
        this.switchConfigState(data.id);
      }
    },
    handleControl(type, data) {
      switch (type) {
        case "topping":
          this.toppingComponent(data.id);
          break;
        case "moveUp":
          this.upAndDown({ id: data.id, type: "moveUp" });
          break;
        case "moveDown":
          this.upAndDown({ id: data.id, type: "moveDown" });
          break;
        case "delete":
          this.delComponent(data.id);
          const obj = this.domList.find((item) => item.id == data.id);
          this.domList = this.domList.filter((item) => item.id != data.id);
          // 将左侧组件恢复可拖拽状态
          if (obj) obj.dom.className = "wrap draw";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.integralShop {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .peak {
    position: relative;
    width: 100%;
    img {
      width: 100%;
    }
    .title {
      position: absolute;
      left: 50%;
      top: 60%;
      transform: translate(-50%);
      margin: 0;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }
  .background {
    position: relative;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 98px;
    }
    &.active {
      border: 2px dashed #4878ff;
    }
  }
  .scoreSet {
    box-sizing: border-box;
    padding: 0 18px;
    transform: translateY(-50%);
    .setWrap {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 18px 0;
      height: 110px;
      background-color: #fff;
      border-radius: 6px;
      &.active {
        border: 2px dashed #4878ff;
      }
    }
    .left,
    .right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .left {
      flex-direction: column;
      border-right: 1px solid #ddd;
      span {
        &:first-child {
          color: #666;
          font-size: 13px;
          font-weight: 500;
        }
        &:last-child {
          margin-top: 4px;
          color: #dc4e40;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .right {
      color: #000000;
      font-size: 15px;
      font-weight: 500;
      .uploadImg {
        margin-right: 8px;
        height: 32px;
      }
    }
  }
  .list {
    flex: 1;
    transform: translateY(-55px);
    li {
      position: relative;
    }
    .activityList {
      box-sizing: border-box;
      margin-left: 18px;
      margin-right: 18px;
      background-color: #fff;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      &.active {
        border: 2px dashed #4878ff;
      }
      .activityItem {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 30px 0;
        margin: 0 14px;
        border-bottom: 1px solid #e6e6e6;
        &:last-child {
          border: none;
        }
        .activityIcon {
          flex-shrink: 0;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 14px;
        }
        .activityInfo {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          .name {
            color: #000;
            font-size: 15px;
            font-weight: bold;
          }
          .desc {
            margin: 6px 0;
            color: #999999;
            font-size: 12px;
            font-weight: 400;
          }
          .time {
            color: #f87541;
            font-size: 11px;
            font-weight: 400;
          }
        }
        .joinBtn {
          flex-shrink: 0;
          width: 106px;
          height: 38px;
          line-height: 38px;
          text-align: center;
          border-radius: 35px;
          background-color: #dc4e40;
          cursor: pointer;
          color: #fff;
          font-size: 11px;
          font-weight: 500;
        }
      }
      h4 {
        box-sizing: border-box;
        padding-left: 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        text-align: left;
        color: #000;
        font-weight: bold;
      }
    }
  }
}
</style>
